import {EnumLanguage} from "../EnumLanguage";

export const UXPrice = {
    description: {
        [EnumLanguage.en] : 'A section on what is included in the basic version of the MIS and what additional modules exist.',
        [EnumLanguage.ru]: 'Раздел о том, что входит в базовую версию МИС и какие существуют дополнительные модули.'
    },
    image: {
        altImage: {
            [EnumLanguage.ru]: 'Скриншот к модулю',
            [EnumLanguage.en]: 'Screenshot to module',
            [EnumLanguage.cn]: '模块截图',
        }
    },
    adminButtons: {
        editModules: {
            [EnumLanguage.ru]: 'Редактировать модули',
            [EnumLanguage.en]: 'Edit modules',
        },
        cancelEdit: {
            [EnumLanguage.ru]: 'Отменить редактирование',
            [EnumLanguage.en]: 'Cancel edit',
        }
    },
    basicVersion: {
        title: {
            [EnumLanguage.ru]: 'Базовая версия',
            [EnumLanguage.en]: 'Basic version',
            [EnumLanguage.cn]: '基础版',
        }
    },
    additionalModules: {
        title: {
            [EnumLanguage.ru]: 'Дополнительные модули',
            [EnumLanguage.en]: 'Additional modules',
            [EnumLanguage.cn]: '附加模块',
        },
        price: {
            noPrice: {
                [EnumLanguage.ru]: 'Стоимость не указана',
                [EnumLanguage.en]: 'No price',
                [EnumLanguage.cn]: '没有价格',
            },

        },

    }
}